// extracted by mini-css-extract-plugin
export default {"about":"about_about__XtGV4","intro":"about_intro__xEEDc","features":"about_features__n2Q0Y","item":"about_item__bKDcA","revenue":"about_revenue__F64cY"};